module.exports = __webpack_public_path__ + "img/step8.55d754ae.png";